import { all } from 'redux-saga/effects';

import { watchCreateUser } from './create';
import { watchDeleteuser } from './delete';
import { watchFetchUser } from './fetch';

export function* userSaga() {
  yield all([watchCreateUser(), watchDeleteuser(), watchFetchUser()]);
}